import React from "react";
import { DefaultButton, Modal, Label, Stack } from "@fluentui/react";
import { ModalPromoteToMainProps } from "@/screen/Identities/Interfaces/IdentitiesMainScreenInterfaces";
import { contentStyles, styleLabel, styleDefButton, styleCancelButton } from "@/screen/Identities/Styles/IdentitiesMainScreenStyles";

/**
 * Confirmación para convertir un interviniente en el principal de la cuenta. Es irreversible: el principal
 * vacío actual se elimina. "No" solo cierra; no se guarda ninguna decisión.
 */
const ModalPromoteToMain: React.FC<ModalPromoteToMainProps> = ({isOpen, identityFullName, errorMessage, isSubmitting, onConfirm, onCancel}) =>
{
    const showError = Boolean(errorMessage);
    const displayName = identityFullName.trim() !== "" ? identityFullName : "este interviniente";
    return(
        <Modal isOpen={isOpen}>
            <div className={contentStyles.header}>
                <Label styles={styleLabel}>Cambio de interviniente principal</Label>
            </div>
            <div className={contentStyles.body}>
                <p>
                    ¿Quieres que{" "}<strong>{displayName}</strong>{" "}sea el interviniente principal de tu cuenta?
                </p>
                <p style={{marginTop: "12px", fontSize: "14px", cursor: "default", lineHeight: "1.4"}}>
                    Si confirmas, este interviniente pasará a ser el principal de tu cuenta y el interviniente principal vacío que tienes ahora se eliminará.
                </p>
                <p style={{marginTop: "12px", color: "#a4262c", fontSize: "14px", cursor: "default", lineHeight: "1.4"}}>
                    <strong>Esta decisión no se puede deshacer.</strong>
                </p>
                {showError &&
                (
                    <p role="alert"
                        style={
                        {
                            marginTop: "14px",
                            padding: "10px 12px",
                            borderRadius: "4px",
                            backgroundColor: "rgba(204, 33, 79, 0.08)",
                            color: "#a4262c",
                            cursor: "default",
                            fontSize: "14px",
                            lineHeight: "1.4",
                        }}
                    >
                        {errorMessage}
                    </p>
                )}
            </div>
            <Stack.Item style={{display: "flex", justifyContent: "center", padding: "10px", gap: "10px"}}>
                <DefaultButton styles={styleCancelButton} onClick={onCancel} disabled={isSubmitting}>
                    No
                </DefaultButton>
                <DefaultButton styles={styleDefButton} onClick={onConfirm} disabled={isSubmitting} text={isSubmitting ? "Enviando…" : "Sí, hacerlo mi principal"} />
            </Stack.Item>
        </Modal>
    );
};

export default ModalPromoteToMain;
